/* @HEADER
 * @version 1.0.1627 | 2026-09-20
 * @purpose How far the main column is scrolled right now — the one DOM read the host's navigation captures into a snapshot before a move (ZVX-DEV-1616). Out of App.tsx with a proof of its own (ZVX-DEV-6144, App.tsx-by-meaning S5); the element is the shell's <main id="main-content">.
 * @sidecar captureMainScroll.ts.header.md
 * @layer app | @hex adapter | @ctx app
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-6144, ZVX-DEV-1616

/** The id AppShell gives its scrolling main column. */
export const MAIN_CONTENT_ID = 'main-content'

/** 0 when the column is not mounted (a test, an overlay route) — a snapshot never fails for want of a scroll position. */
export function captureMainScroll(doc: Pick<Document, 'getElementById'> | null = typeof document === 'undefined' ? null : document): number {
  return doc?.getElementById(MAIN_CONTENT_ID)?.scrollTop ?? 0
}
